import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment-timezone';

import { Box, Button, Grid, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import Assignment from '../../Components/Assignment/Assignment';
import AssignModal from '../../Components/Modals/AssignModal';

import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/system';

function ClassAssignments(props) {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [assignments, setAssignments] = useState([]);
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    function handleClose() {
      loadAssignments();
      setOpen(false);
    }

    async function loadAssignments() {
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}/api/forms/assignments/${state.class_id}/responses`,
        { headers: {Authorization: `Bearer ${state.token.access_token}`}}
      );
      let assignmentsData = response.data;
      assignmentsData.map((assignment) => {
        let temp = assignment;
        let start = moment.utc(assignment.start, moment.ISO_8601, true);
        let end = moment.utc(assignment.end, moment.ISO_8601, true);
        temp.start = start.local().format("MMMM Do YYYY, h:mm a");
        temp.end = end.local().format("MMMM Do YYYY, h:mm a");
        temp.startDate = start.format("YYYY-MM-DD");
        temp.startTime = start.format("HH:mm");
        temp.endDate = end.format("YYYY-MM-DD");
        temp.endTime = end.format("HH:mm");
        return temp;
      })
      setAssignments(assignmentsData);
    }

    useEffect(() => {
      loadAssignments(state);
    }, [open])

    return (
      <Box>
        <DashboardNavbar userType="admin"/>
        <Box sx={{ px: 3, my: 3, marginInline: "auto", maxWidth: 1400}}>
          <Grid container spacing={3}>
              <Grid item xs={12} sx={{display: "flex", gap: 2, marginBottom: 2}}>
                <Button variant='outlined' sx={{height: 32, alignSelf: "center"}} onClick={() => navigate("/classview", { state: state })} startIcon={<ArrowBackIcon/>}>
                  Class
                </Button>
                <Typography variant='h4'>Assignments</Typography>
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <Stack spacing={1}>
                  <Button variant='contained' onClick={() => navigate("/forms", { state: state })} style={{backgroundColor: '#2E2E2E'}}>Manage Forms</Button>
                  <Button variant='contained' onClick={handleOpen} style={{backgroundColor: '#2E2E2E'}}>Create New Assignment</Button>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={8} md={9}>
                <Stack spacing={2}>
                {
                  assignments.map((assignment) => (
                    <Assignment key={assignment.assignment_id} assignment={assignment} state={state}/>
                  ))
                }
                </Stack>
              </Grid>
          </Grid>
        </Box>
        <AssignModal open={open} handleClose={handleClose} state={state}/>
      </Box>
    );
}

export default ClassAssignments;